import { z } from 'zod';

/** Revenue trend report — how many trailing months to include, defaulting to a year. */
export const crmRevenueQuerySchema = z.object({
  months: z.coerce.number().int().min(1).max(36).default(12),
});

export type CrmRevenueQuery = z.infer<typeof crmRevenueQuerySchema>;
